import type { VersionedPage } from '@diana/contracts';
import { z } from 'zod';

const media = z.object({ assetId: z.uuid() });
const heroCover = z.object({
  media: media.optional(),
  imageComposition: z
    .object({ desktop: z.object({ media: media.optional() }).optional() })
    .optional(),
  slides: z.array(z.object({ media: media.optional() })).optional(),
});

/** Use the real primary Hero image, never a social/SEO image or an unrelated block. */
export function pageCover(page: VersionedPage): string | undefined {
  const hero = page.blocks.find((block) => block.type === 'Hero' && block.enabled);
  const parsed = heroCover.safeParse(hero?.payload);
  if (!parsed.success) return undefined;
  const payload = parsed.data;
  const asset =
    payload.imageComposition?.desktop?.media ?? payload.media ?? payload.slides?.[0]?.media;
  return asset ? `/api/v1/admin/assets/${asset.assetId}/preview` : undefined;
}
